import React from "react";
import { ChevronRight } from "lucide-react";
import { cn } from "../../../lib/utils";

/**
 * One-line summary rows. Each opens its detail in a sheet; the value says what
 * is set now, highlighted when it differs from the default.
 */
const DetailRows = ({ rows, onOpen }) => (
  <div className="overflow-hidden rounded-xl border border-border bg-card">
    {rows.map(({ key, Icon, label, value, changed }, i) => (
      <button
        key={key}
        type="button"
        onClick={() => onOpen(key)}
        className={cn(
          "grid w-full grid-cols-[1.25rem_auto_minmax(0,1fr)_1rem] items-center gap-2.5 px-3 py-3 text-left transition-colors hover:bg-muted/30",
          i > 0 && "border-t border-border",
        )}
      >
        <Icon className="h-[18px] w-[18px] text-muted-foreground" />
        <span className="text-sm font-medium text-foreground">{label}</span>
        <span
          className={cn(
            "truncate text-right text-[13px]",
            changed ? "text-foreground" : "text-muted-foreground",
          )}
        >
          {value}
        </span>
        <ChevronRight className="h-4 w-4 text-muted-foreground/70" />
      </button>
    ))}
  </div>
);

export default DetailRows;
